module.exports = __webpack_public_path__ + "static/profile-c8b3a0a0b4240904b49ec336b6a23233.jpg";